import SectionHeading from "./SectionHeading";
import { latestReports } from "@/mocks/critter";

export default function LatestReports() {
  const featured = latestReports[0];
  const rest = latestReports.slice(1);

  return (
    <section id="reports" className="scroll-mt-24 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="Latest Reports"
            title="最新深读"
            desc="每周更新的调查报道与风险解析，不追逐流量，只追逐那些值得讲清的事。"
          />
          <a
            href="#columns"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            查看全部栏目 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* featured */}
        <article className="group mt-9 grid grid-cols-1 overflow-hidden rounded-lg border border-background-300 bg-background-100 lg:grid-cols-[1.1fr_1fr]">
          <div className="relative h-56 sm:h-72 lg:h-auto">
            <img
              src={featured.img}
              alt={featured.alt}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
            />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-primary-600 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-fire-fill"></i> 主编推荐
            </span>
          </div>
          <div className="flex flex-col justify-center p-6 md:p-9">
            <div className="flex flex-wrap items-center gap-2 text-xs">
              <span className="rounded-full bg-secondary-200 px-2.5 py-0.5 font-medium text-secondary-900">
                {featured.tag}
              </span>
              <span className="text-foreground-500">{featured.date} 发布</span>
              <span className="text-foreground-400">·</span>
              <span className="text-foreground-500">阅读 {featured.read}</span>
            </div>
            <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
              {featured.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
            <div className="mt-6 flex flex-wrap items-center gap-4">
              <button
                type="button"
                className="cursor-pointer inline-flex items-center gap-2 rounded-md bg-primary-600 px-4 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-700 transition-colors whitespace-nowrap"
              >
                深入阅读 <i className="ri-arrow-right-line text-sm"></i>
              </button>
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-user-heart-line"></i> 文 / 呱呱调查组
              </span>
            </div>
          </div>
        </article>

        {/* rest */}
        <div className="mt-7 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((r) => (
            <article
              key={r.title}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={r.img}
                  alt={r.alt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.05]"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex flex-wrap items-center gap-2 text-[11px]">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-900">
                    {r.tag}
                  </span>
                  <span className="text-foreground-400">{r.date}</span>
                  <span className="text-foreground-400">·</span>
                  <span className="text-foreground-400">{r.read}</span>
                </div>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {r.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-3">
                  {r.excerpt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                  阅读全文 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}